import type { MouseEvent, ReactNode } from 'react';

export const clickableRef = (label: string, onClick?: () => void): ReactNode => {
  if (!onClick || !label || label === '—') return label || '—';
  return (
    <button
      type="button"
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        color: 'inherit',
        cursor: 'pointer',
        textDecoration: 'underline',
        font: 'inherit',
      }}
      onClick={(event: MouseEvent) => {
        event.stopPropagation();
        onClick();
      }}
    >
      {label}
    </button>
  );
};
